import antdEsEC from 'antd/es/locale/es_ES';
import esMsg from "../locales/es_ES.json";

const EsLang = {
  antd: antdEsEC,
  locale: 'es-ES',
  messages: {
    ...esMsg
  },
};
export default EsLang;
